import { useMemo } from 'react'
import { BigNumber } from '@ethersproject/bignumber'
// import { CheckmarkCircleIcon, CheckmarkCircleFillIcon, Tag, useTooltip } from 'uikit'
import { useTooltip, Text } from 'uikit'

import { useTranslation } from 'react-i18next'
import { ethersToBigNumber } from 'utils/bigNumber'
import { REWARD_RATE } from 'state/predictions/config'
import { useConfig } from 'pages/Predictions/context/ConfigProvider'
import { formatBnbv2 } from '../../helpers'
import styled from 'styled-components'
import { Image } from 'components'

interface EnteredTagProps {
  amount?: BigNumber
  hasClaimed?: boolean
  multiplier: string
  isUp: boolean
}

const Tag = styled.div<{ isUp: boolean }>`
  width: 89px;
  height: 36px;
  background: #fc9c47;
  border-radius: ${({ isUp }) => (isUp ? '0 24px 24px 0' : '24px 0 0 24px')};
  position: relative;
  right: -16px;
  bottom: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
`

const EnteredTag: React.FC<React.PropsWithChildren<EnteredTagProps>> = ({
  amount,
  hasClaimed = false,
  multiplier,
  isUp = false,
}) => {
  const { t } = useTranslation()
  const { displayedDecimals, payToken } = useConfig()

  const formattedAmount = useMemo(() => {
    let tokenAmount
    if (hasClaimed) {
      if (amount) {
        const multiplierNumber = parseFloat(multiplier)
        tokenAmount = BigNumber.from(
          ethersToBigNumber(amount)
            .times(Number.isFinite(multiplierNumber) ? multiplierNumber * REWARD_RATE : 1)
            .toFixed(0)
        )
      }
    } else {
      tokenAmount = amount
    }
    return formatBnbv2(tokenAmount, displayedDecimals)
  }, [amount, displayedDecimals, hasClaimed, multiplier])

  const { targetRef, tooltipVisible, tooltip } = useTooltip(
    <div style={{ whiteSpace: 'nowrap', fontSize: '14px' }}>{`${formattedAmount} ${payToken.symbol}`}</div>,
    { placement: 'bottom' }
  )

  return (
    <>
      <div ref={targetRef}>
        {/* <Tag
          variant="secondary"
          fontWeight="bold"
          textTransform="uppercase"
          outline={!hasClaimed}
          // startIcon={hasClaimed ? <CheckmarkCircleFillIcon width="18px" /> : <CheckmarkCircleIcon width="18px" />}
        >
          {hasClaimed ? t('Claimed') : t('Entered')}
        </Tag>{' '} */}
        <Tag isUp={isUp}>
          <Image
            src={require('assets/images/prediction/success.svg').default}
            style={{ width: '16px', height: '16px' }}
          />
          <Text fontSize="14px" color="white" bold ml="5px">
            {hasClaimed ? t('PREDICTION_62') : t('PREDICTION_63')}
          </Text>
        </Tag>
      </div>
      {tooltipVisible && tooltip}
    </>
  )
}

export default EnteredTag
